import { useAppSelector } from 'app/hooks';
import { Header } from 'components';
import { useCommunity } from "components/CommunityContext";
import { Status } from 'models/member';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { selectProfile } from 'redux/selectors/profile';

const WaitingReview = (): JSX.Element => {
  const navigate = useNavigate();
  const user = useAppSelector(selectProfile);
  const { texts: { waitingReview } } = useCommunity();
  useEffect(() => {
    if (user?.status !== Status.AWAITING_REVIEW) {
      navigate('/');
    }
  }, [user, navigate]);

  return (
    <>
      <div className="waiting-review-container">
        <Header withBackArrow={false}></Header>
        <div className="container waiting-review-wrapper">
          <span className="waiting-review-header">{waitingReview?.title}</span>
          <div className="waiting-review-description-container">
            <span className="waiting-review-description">
              {waitingReview?.description}
              <br />
              {waitingReview?.learnMoreLink ? 
              <>
                <br />
                <a className="waiting-review-link" href={waitingReview?.learnMoreLink}>{waitingReview?.learnMoreButton}</a> 
              </>
              : ''}
              <br />
              {waitingReview?.supportEmail ? <a className="waiting-review-link" href={`'mailto:'${waitingReview?.supportEmail}`}>
              {waitingReview?.supportEmail}
              </a> : ''}
            </span>
          </div>
          {/* <div className="link-container">
            <a
              href={waitingReview?.learnMoreLink}
              target="_blank"
              rel="noreferrer"
              className="learn-more-button"
            >
              {waitingReview?.learnMoreButton}
            </a>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default WaitingReview;
